import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { getItemWithExpiration, setItemWithExpiration } from './utils';
import ModalTempMemberUpdatePopup from '../components/modal/ModalTempMemberUpdatePopup';
import { KeepAliveRouteOutlet } from 'keepalive-for-react';
import ModalNewUpdateReviewModal from '@/components/modal/ModalNewUpdateReviewModal';
import ModalCenterReportPermission from '@/scenes/Feed/ModalCenterReportPermission';
import ModalReviewPromotion, { hasSeenReviewPromotionModal } from '@/scenes/Reivew/ModalReviewPromotion';
import MorningBriefingGate from '@/scenes/OpsBriefing/MorningBriefingGate';
import { useUpdatePopupOpen } from '@/components/modal/updatePopupContext';

// 결제상태
// needAction : 최초 접속
// trial : 무료 체험중
// trialPaymentPending : 무료 체험 유예
// plan : 유료 구독
// planWillChanged : 유료 구독 변경예정
// planWillCanceled : 유료 구독 취소예정
// planAborted : 유료 구독 유예
// needPlanToFree : 무료 체험 만료
// needPlanToCharge : 유료 구독 만료

const PrivateRoutes = () => {
    const navigate = useNavigate();
    const [authorization, setAuthorization] = useState(getItemWithExpiration('authorization'));
    const [authObject, setAuthObject] = useState(getItemWithExpiration('authObject'));
    const location = useLocation();
    // const [showPromotionModal, setShowPromotionModal] = useState(false);

    /*
     * 업데이트 소식 팝업이 떠 있는 동안 아침 브리핑 팝업은 잠근다.
     * 로그인 직후에는 둘 다 뜨는 조건이 동시에 성립한다 — `updatePopupContext` 참고.
     */
    const updatePopupOpen = useUpdatePopupOpen();

    // 홍보 모달 표시 체크
    // useEffect(() => {
    //     if (!hasSeenReviewPromotionModal()) {
    //         setShowPromotionModal(true);
    //     }
    // }, []);

    // usableStatus 가 needPlan이면 만료페이지로 던진다. 하지만 expired가 url에 포함되잇으면 네비게이팅멈춘다
    useEffect(() => {
        if (authObject && authObject?.accessMode !== 'view' && authObject?.role !== 'center_viewer') {
            authObject.usableStatus === 'needPlanToFree' &&
                !location.pathname.includes('expired') &&
                navigate('/expired', { replace: true });
            authObject.usableStatus === 'needPlanToCharge' &&
                !location.pathname.includes('expired') &&
                navigate('/expired', { replace: true });
        }
    }, [authObject]);

    // const onClickNerverShowAgain = () => {
    //     setItemWithExpiration('isReviewModalVisible', false, 60 * 60 * 24 * 365);
    //     setIsModalVisible(false);
    // };

    // useEffect(() => {
    //     if (isModalVisible === null) {
    //         setIsModalVisible(true);
    //     } else {
    //         setIsModalVisible(isModalVisible);
    //     }
    // }, []);

    return authorization && authObject ? (
        <>
            <KeepAliveRouteOutlet
                include={['/settlement', '/memberList', '/trainerManage/trainerInfo']}
                exclude={['dash', 'schedule/history']}
            />

            {/* 아침 브리핑 팝업 — 하루 첫 진입 시 1회. 업데이트 소식이 먼저다 */}
            <MorningBriefingGate suspended={updatePopupOpen} />

            {/* 홍보 모달 */}
            {/* {showPromotionModal && (
                <ModalReviewPromotion
                    unmount={() => setShowPromotionModal(false)}
                    onClickLearnMore={() => {
                        // 자세히 알아보기 클릭 시 동작 (필요시 수정)
                        window.open('https://mustmove.notion.site/V2-22af3bc81d1a801ab5a3c119e19a731b', '_blank');
                    }}
                />
            )} */}

            {/* {isModalVisible && (
                <ModalNewUpdateReviewModal
                    setIsVisible={setIsModalVisible}
                    onClose={onClickNerverShowAgain}
                    onClickReviewPermission={() => {
                        setIsModalVisible(false);
                        setIsReviewPermissionModalVisible(true);
                        onClickNerverShowAgain();
                    }}
                />
            )} */}
        </>
    ) : (
        <Navigate to="/signIn" />
    );
};

export default PrivateRoutes;
